import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _merge from "lodash/fp/merge";

var _table;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}
/* eslint-disable react/jsx-pascal-case */


import { ComponentsProvider, theme, useConfig } from 'docz';
import baseComponents from 'gatsby-theme-docz/src/components';
import defaultConfig from 'gatsby-theme-docz/src/theme';
import React from 'react';
import { Styled, ThemeProvider } from 'theme-ui';
import { jsx as ___EmotionJSX } from "@emotion/core";

var componentsMap = _objectSpread({}, baseComponents); // eslint-disable-next-line react/prop-types


var Theme = function Theme(_ref) {
  var children = _ref.children;
  var config = useConfig();
  return ___EmotionJSX(ThemeProvider, {
    theme: config.themeConfig
  }, ___EmotionJSX(ComponentsProvider, {
    components: componentsMap
  }, ___EmotionJSX(Styled.root, null, children)));
};

var themeConfig = _merge(defaultConfig, {
  initialColorMode: 'light',
  colors: {
    modes: {
      light: {
        grayLighter: '#d0d0d0',
        gray2: '#aaa',
        background2: '#fff',
        info: 'rgb(56, 132, 255)',
        success: 'rgb(0, 204, 136)',
        warning: 'rgb(255, 204, 0)',
        danger: 'rgb(243, 32, 19)',
        default: 'rgb(0, 0, 0, .3)',
        infoLight: 'rgba(56, 132, 255, .1)',
        successLight: 'rgba(0, 219, 136, .1)',
        warningLight: 'rgba(255, 204, 0, .1)',
        dangerLight: 'rgba(243, 32, 19, .1)',
        defaultLight: 'rgba(0, 0, 0, .04)',
        backdrop: 'rgba(0, 0, 0, .15)'
      },
      dark: {
        grayLighter: '#bbb',
        gray2: '#aaa',
        background2: 'rgba(0,0,0,.1)',
        info: 'rgb(56, 132, 255)',
        success: 'rgb(0, 204, 136)',
        warning: 'rgb(255, 204, 0)',
        danger: 'rgb(243, 32, 19)',
        default: 'rgb(255, 255, 255, .6)',
        infoLight: 'rgba(56, 132, 255, .1)',
        successLight: 'rgba(0, 219, 136, .1)',
        warningLight: 'rgba(255, 204, 0, .1)',
        dangerLight: 'rgba(243, 32, 19, .1)',
        defaultLight: 'rgba(255, 255, 255, .3)',
        backdrop: 'rgba(255, 255, 255, .15)'
      }
    }
  },
  boxShadow: '0 3px 7px 0 rgba(105, 111, 132, 0.1)',
  styles: {
    root: {
      fontFamily: "'Source Sans Pro', 'Roboto', sans-serif",
      fontSize: '18px',
      color: 'text',
      bg: 'background'
    },
    h1: {
      fontFamily: 'inherit'
    },
    h2: {
      fontFamily: 'inherit'
    },
    h3: {
      fontFamily: 'inherit'
    },
    code: {
      fontFamily: 'Consolas, monaco, monospace'
    },
    inlineCode: {
      position: 'relative',
      display: 'inline-block',
      fontFamily: 'Consolas, monaco, monospace',
      backgroundColor: defaultConfig.colors.blockquote.bg,
      color: defaultConfig.colors.grayDark,
      fontSize: '0.85em',
      letterSpacing: '-0.3px',
      padding: '3px 8px',
      borderRadius: '3px'
    },
    table: (_table = {
      width: '100%',
      my: 4,
      borderCollapse: 'collapse',
      borderSpacing: 0
    }, _table[['th', 'td']] = {
      textAlign: 'left',
      py: '12px',
      pr: '12px',
      pl: '12px',
      borderColor: 'border',
      borderBottomStyle: 'solid'
    }, _table),
    th: {
      verticalAlign: 'middle',
      borderBottomWidth: '1px'
    },
    td: {
      verticalAlign: 'middle',
      borderBottomWidth: '1px'
    },
    hr: {
      margin: '3rem 0 !important'
    }
  }
});

var __DOCZ_DUMMY_EXPORT_DEFAULT = theme(themeConfig)(Theme);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !Object.prototype.hasOwnProperty.call(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/index.js"
    }
  });
}